class ReadingLevel {
    /**
	 * Create a new instance of a reading level object
	 * @param  {object} lexileData A lexile data object from novelist select
	 */
	constructor(lexileData) {
		this.lexile = lexileData.Lexile;		
		this.numericLexile = lexileData.NumericLexile;
		this.audienceLevel = lexileData.AudienceLevel;
	}
}

export default ReadingLevel;


// WEBPACK FOOTER //
// ./src/models/ReadingLevel.js